import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import P from '@deliveroo/consumer-component-library/components/P';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import StarRating from '../RestaurantStarRating';
import CustomerReview from '../CustomerReview';
import styles from './RestaurantReviewsCard.scss';

/**
 * A card presenting three customer reviews for a given restaurant.
 */
export default function RestaurantReviewsCard({
  imageUrl,
  restaurantName,
  restaurantLink,
  rating,
  reviews,
  readMoreLinkText,
}) {
  return (
    <div className={styles.card}>
      <a href={restaurantLink} className={styles.restaurant}>
        <span className={styles.imageContainer}>
          <BackgroundImage src={imageUrl} />
        </span>
        <div className={styles.meta}>
          <P isBold>{restaurantName}</P>
          <Spacer adjacentVerticalSpacing="x-small">
            <StarRating value={rating.value} count={rating.count} />
          </Spacer>
        </div>
        <div className={styles.mobileLink}>
          <Icon component={ArrowRight} color="teal" />
        </div>
      </a>
      <Spacer spacing="medium">
        {reviews.map(({ rating: stars, reviewerName, content }) => (
          <CustomerReview
            key={`${reviewerName}-${content}`}
            rating={stars}
            reviewerName={reviewerName}
            content={content}
            readMoreLinkText={readMoreLinkText}
          />
        ))}
      </Spacer>
    </div>
  );
}

RestaurantReviewsCard.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  restaurantName: PropTypes.string.isRequired,
  restaurantLink: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    value: PropTypes.number.isRequired,
    count: PropTypes.string,
  }).isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      rating: PropTypes.number.isRequired,
      reviewerName: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
  readMoreLinkText: PropTypes.string.isRequired,
};
